// extracted by mini-css-extract-plugin
export var outer = "Dice-module--outer--Tgv2w";